$eve_checkbox $eve_button
	indeterminate? null
	disabled? null
	colors? \primary
	size null
	click_toggle? true
	attr *
		^
		mol_check_checked <= checked? false
		aria-checked <= aria_checked \false
		role <= aria_role \checkbox
	event *
		^
		click?event <=> event_click?event null
	sub /
		<= Icon $mol_icon_check

